import React from "react"; // eslint-disable-line no-unused-vars
import { Link } from "react-router-dom";

const ProductCard = ({ title, subTitle, availableToPatientPortalForSearch, id, searchState }) => {
  return (
    availableToPatientPortalForSearch && (
      <div className="product-card">
        <div className="card-content">
          <div className="pr-3">
            <div>
              <Link
                to={{ pathname: `/products/${id}`, state: searchState }}
                id="drugTitle"
                className="title"
                data-tag="track-link"
                data-analytics-text={`Product Details ${id}`}
              >
                {title}
              </Link>
            </div>
            <div id="drugSubTitle" className="sub-title">
              {subTitle}
            </div>
          </div>
          <div style={{ marginLeft: "auto" }}>
            <Link
              to={{ pathname: `/products/${id}`, state: searchState }}
              data-tag="track-link"
              data-analytics-text={`Product Details ${id}`}
            >
              <div name="arrowBtn" className="arrow-link" />
            </Link>
          </div>
        </div>
      </div>
    )
  );
};

export default ProductCard;



// WEBPACK FOOTER //
// ./src/mi-app/products/ProductCard.js